import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { AIAnswerQueryStreamType, NLPSearchErrorState, NLPSearchResultFormat } from '../ai-answer-dialog/types';
import { ASSISTANCE_SERVICE_API_BASE_URL, SAIN_STREAMING_API } from '../constants';
import { isStreamAnswerPart, isStreamError, isStreamFollowUp, isStreamResponse } from './types';
var identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
function getAgentAndExperience(isReadingAids) {
  return isReadingAids ? {
    named_id: 'reading_aids_agent',
    experience: 'reading-aids'
  } : {
    named_id: 'sain_agent',
    experience: 'sain'
  };
}
function mapMimeTypeToFormat(mimeType) {
  switch (mimeType) {
    case 'text/markdown':
      return NLPSearchResultFormat.MARKDOWN;
    case 'text/adf':
      return NLPSearchResultFormat.ADF;
    case 'text/json':
      return NLPSearchResultFormat.JSON;
    default:
      return NLPSearchResultFormat.MARKDOWN;
  }
}
function mapErrorToSain(error) {
  var errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
  switch (errorMessage) {
    case 'NO_ANSWER_LLM':
      return NLPSearchErrorState.NoAnswer;
    case 'NO_ANSWER_PEOPLE':
      return NLPSearchErrorState.NoAnswerWhoQuestion;
    case 'NO_ANSWER_KEYWORDS':
      return NLPSearchErrorState.NoAnswerKeywords;
    case 'NO_ANSWER_SEARCH_QA_PLUGIN':
      return NLPSearchErrorState.NoAnswerSearchResults;
    case 'ACCEPTABLE_USE_VIOLATIONS':
      return NLPSearchErrorState.AcceptableUseViolation;
    case 'OPENAI_RATE_LIMIT_USER_ABUSE':
      return NLPSearchErrorState.NoAnswerOpenAIRateLimitUserAbuse;
    case 'FEATURE_DISABLED_ON_SITE':
      return NLPSearchErrorState.AIDisabled;
    default:
      return NLPSearchErrorState.NetworkError;
  }
}
function mapMessageToNLPSearchType(message) {
  var _message$message$sour, _message$message$sour2, _message$message$mess, _message$message$mess2;
  return {
    nlpResult: message.message.content,
    uniqueSources: (_message$message$sour = (_message$message$sour2 = message.message.sources) === null || _message$message$sour2 === void 0 ? void 0 : _message$message$sour2.map(function (source) {
      var _source$id;
      return {
        ari: source.ari,
        id: (_source$id = source.id) === null || _source$id === void 0 ? void 0 : _source$id.toString(),
        title: source.title,
        type: source.type,
        url: source.url,
        lastModified: source.lastModified,
        iconUrl: null,
        spaceName: null,
        spaceUrl: null
      };
    })) !== null && _message$message$sour !== void 0 ? _message$message$sour : [],
    disclaimer: (_message$message$mess = (_message$message$mess2 = message.message.message_metadata) === null || _message$message$mess2 === void 0 ? void 0 : _message$message$mess2.disclaimer) !== null && _message$message$mess !== void 0 ? _message$message$mess : null,
    errorState: null,
    format: mapMimeTypeToFormat(message.message.content_mime_type),
    extraAPIAnalyticsAttributes: {
      message_id: message.message.id,
      conversational_channel_id: message.message.conversation_channel_id,
      experience_id: message.message.experience_id,
      user_id: message.message.user_ari.replace(identityUserCloudARIPrefix, '')
    }
  };
}
function mapStreamResponse(response) {
  if (isStreamError(response)) {
    return {
      type: AIAnswerQueryStreamType.FinalResponse,
      message: {
        errorState: mapErrorToSain(response),
        errorCode: response.message.status_code,
        disclaimer: null,
        format: NLPSearchResultFormat.MARKDOWN,
        uniqueSources: []
      }
    };
  }
  if (isStreamAnswerPart(response)) {
    return {
      type: AIAnswerQueryStreamType.AnswerPart,
      message: {
        nlpResult: response.message.content
      }
    };
  }
  if (isStreamResponse(response)) {
    return {
      type: AIAnswerQueryStreamType.FinalResponse,
      message: mapMessageToNLPSearchType(response.message)
    };
  }
  if (isStreamFollowUp(response)) {
    var _response$message$fol;
    return {
      type: 'follow-up',
      queries: (_response$message$fol = response.message.follow_up_queries) !== null && _response$message$fol !== void 0 ? _response$message$fol : []
    };
  }
  return {
    // Don't currently handle other types, such as PLUGIN_INVOCATION, TRACE etc
    type: 'other'
  };
}
export function sainStreamFetchHandler(_x) {
  return _sainStreamFetchHandler.apply(this, arguments);
}
function _sainStreamFetchHandler() {
  _sainStreamFetchHandler = _wrapAsyncGenerator(function (_ref) {
    var fetchReturn = _ref.fetchReturn,
      variables = _ref.variables,
      fetchConfig = _ref.fetchConfig;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref2, query, locale, experience, filters, cloudIdARI, followUpsEnabled, url, response, _finalResponse, reader, decoder, buffer, done, finalResponse, _yield$_awaitAsyncGen, value, doneReading, chunkValue, lines, line, parsedData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _ref2 = variables || {}, query = _ref2.query, locale = _ref2.locale, experience = _ref2.experience, filters = _ref2.filters, cloudIdARI = _ref2.cloudIdARI, followUpsEnabled = _ref2.followUpsEnabled;
            url = "".concat((fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.hostName) || '').concat(SAIN_STREAMING_API);
            _context.next = 5;
            return _awaitAsyncGenerator(fetchReturn ? fetchReturn : fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                query: query,
                filters: filters,
                locations: [cloudIdARI],
                locale: locale,
                experience: experience,
                followUpsEnabled: followUpsEnabled
              }),
              credentials: (fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.credentials) || 'same-origin' // fetch() uses 'same-origin' by default
            }));
          case 5:
            response = _context.sent;
            if (response.ok) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", {
              state: 'failed',
              reason: 'backend',
              details: 'Unhandled error response received',
              errorCode: response.status
            });
          case 8:
            if (response.body) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", {
              state: 'failed',
              reason: 'backend',
              details: 'response.body missing',
              errorCode: response.status
            });
          case 10:
            _context.prev = 10;
            reader = response.body.getReader();
            decoder = new TextDecoder('utf-8');
            buffer = '';
            done = false;
          case 15:
            if (done) {
              _context.next = 40;
              break;
            }
            _context.next = 18;
            return _awaitAsyncGenerator(reader.read());
          case 18:
            _yield$_awaitAsyncGen = _context.sent;
            value = _yield$_awaitAsyncGen.value;
            doneReading = _yield$_awaitAsyncGen.done;
            done = doneReading;
            chunkValue = decoder.decode(value);
            buffer = buffer + chunkValue;

            // Split the buffer by line breaks
            lines = buffer.split('\n'); // Process all complete lines, except for the last one (which might be incomplete)
          case 25:
            if (!(lines.length > 1)) {
              _context.next = 37;
              break;
            }
            line = lines.shift();
            parsedData = JSON.parse(line);
            if (!(parsedData.type === AIAnswerQueryStreamType.AnswerType || parsedData.type === AIAnswerQueryStreamType.AnswerPart)) {
              _context.next = 33;
              break;
            }
            _context.next = 31;
            return parsedData;
          case 31:
            _context.next = 35;
            break;
          case 33:
            finalResponse = parsedData;
            done = true;
          case 35:
            _context.next = 25;
            break;
          case 37:
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
            _context.next = 15;
            break;
          case 40:
            if (!(((_finalResponse = finalResponse) === null || _finalResponse === void 0 ? void 0 : _finalResponse.type) !== AIAnswerQueryStreamType.FinalResponse)) {
              _context.next = 42;
              break;
            }
            return _context.abrupt("return", {
              state: 'failed',
              reason: 'parsing',
              error: 'Unexpected final response value'
            });
          case 42:
            return _context.abrupt("return", {
              state: 'complete',
              value: finalResponse
            });
          case 45:
            _context.prev = 45;
            _context.t0 = _context["catch"](10);
            return _context.abrupt("return", {
              state: 'failed',
              reason: 'parsing',
              error: _context.t0
            });
          case 48:
            _context.next = 57;
            break;
          case 50:
            _context.prev = 50;
            _context.t1 = _context["catch"](0);
            if (!(_context.t1 instanceof DOMException && _context.t1.name === 'AbortError')) {
              _context.next = 54;
              break;
            }
            return _context.abrupt("return", {
              state: 'failed',
              reason: 'aborted'
            });
          case 54:
            if (!(_context.t1 instanceof Error)) {
              _context.next = 56;
              break;
            }
            return _context.abrupt("return", {
              state: 'failed',
              reason: 'error',
              details: _context.t1.message,
              error: _context.t1
            });
          case 56:
            return _context.abrupt("return", {
              state: 'failed',
              reason: 'unknown'
            });
          case 57:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 50], [10, 45]]);
    })();
  });
  return _sainStreamFetchHandler.apply(this, arguments);
}
var getAgentInput = function getAgentInput(_ref3) {
  var variables = _ref3.variables,
    fetchConfig = _ref3.fetchConfig;
  var _ref4 = variables || {},
    query = _ref4.query,
    locale = _ref4.locale,
    additional_context = _ref4.additional_context;
  return {
    content: query,
    locale: locale,
    additional_context: additional_context,
    entity_ari: fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.entity_ari
  };
};
export function sainStreamFetchHandlerAssistanceService(_x2) {
  return _sainStreamFetchHandlerAssistanceService.apply(this, arguments);
}
function _sainStreamFetchHandlerAssistanceService() {
  _sainStreamFetchHandlerAssistanceService = _wrapAsyncGenerator(function (_ref5) {
    var fetchReturn = _ref5.fetchReturn,
      variables = _ref5.variables,
      isReadingAids = _ref5.isReadingAids,
      fetchConfig = _ref5.fetchConfig,
      _ref5$generatorConfig = _ref5.generatorConfig,
      generatorConfig = _ref5$generatorConfig === void 0 ? {
        yieldAnswerPart: true,
        yieldFinalResponse: false
      } : _ref5$generatorConfig,
      onStreamFinalResponse = _ref5.onStreamFinalResponse;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref6, filters, _getAgentAndExperienc, experience, named_id, url, response, _finalResponse3, reader, decoder, buffer, done, finalResponse, _yield$_awaitAsyncGen2, value, doneReading, chunkValue, lines, line, parsedData, _finalResponse2;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _ref6 = variables || {}, filters = _ref6.filters;
            _getAgentAndExperienc = getAgentAndExperience(isReadingAids), experience = _getAgentAndExperienc.experience, named_id = _getAgentAndExperienc.named_id;
            url = "".concat((fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.hostName) || '').concat(ASSISTANCE_SERVICE_API_BASE_URL, "/chat/v1/invoke_agent/stream");
            _context2.next = 6;
            return _awaitAsyncGenerator(fetchReturn ? fetchReturn : fetch(url, {
              method: 'POST',
              headers: _objectSpread({
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience
              }, fetchConfig !== null && fetchConfig !== void 0 && fetchConfig.headers ? fetchConfig.headers : {}),
              body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: _objectSpread(_objectSpread({}, getAgentInput({
                  variables: variables,
                  fetchConfig: fetchConfig
                })), {}, {
                  filters: filters
                })
              }),
              credentials: (fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.credentials) || 'same-origin',
              // fetch() uses 'same-origin' by default
              signal: fetchConfig !== null && fetchConfig !== void 0 && fetchConfig.timeout ? AbortSignal.timeout(fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.timeout) : undefined
            }));
          case 6:
            response = _context2.sent;
            if (response.ok) {
              _context2.next = 9;
              break;
            }
            return _context2.abrupt("return", {
              state: 'failed',
              reason: 'backend',
              details: 'Unhandled error response received',
              errorCode: response.status
            });
          case 9:
            if (response.body) {
              _context2.next = 11;
              break;
            }
            return _context2.abrupt("return", {
              state: 'failed',
              reason: 'backend',
              details: 'response.body missing',
              errorCode: response.status
            });
          case 11:
            _context2.prev = 11;
            reader = response.body.getReader();
            decoder = new TextDecoder('utf-8');
            buffer = '';
            done = false;
            _context2.next = 18;
            return {
              type: AIAnswerQueryStreamType.AnswerType,
              message: {
                format: NLPSearchResultFormat.MARKDOWN
              }
            };
          case 18:
            if (done) {
              _context2.next = 59;
              break;
            }
            _context2.next = 21;
            return _awaitAsyncGenerator(reader.read());
          case 21:
            _yield$_awaitAsyncGen2 = _context2.sent;
            value = _yield$_awaitAsyncGen2.value;
            doneReading = _yield$_awaitAsyncGen2.done;
            done = doneReading;
            chunkValue = decoder.decode(value);
            buffer = buffer + chunkValue;

            // Split the buffer by line breaks
            lines = buffer.split('\n'); // Process all complete lines, except for the last one (which might be incomplete)
          case 28:
            if (!(lines.length > 1)) {
              _context2.next = 56;
              break;
            }
            line = lines.shift();
            parsedData = mapStreamResponse(JSON.parse(line));
            if (!(parsedData.type === 'other')) {
              _context2.next = 35;
              break;
            }
            return _context2.abrupt("continue", 28);
          case 35:
            if (!(parsedData.type === AIAnswerQueryStreamType.AnswerType || parsedData.type === AIAnswerQueryStreamType.AnswerPart)) {
              _context2.next = 41;
              break;
            }
            if (!generatorConfig.yieldAnswerPart) {
              _context2.next = 39;
              break;
            }
            _context2.next = 39;
            return parsedData;
          case 39:
            _context2.next = 54;
            break;
          case 41:
            if (!(parsedData.type === 'follow-up')) {
              _context2.next = 48;
              break;
            }
            if (!(!((_finalResponse2 = finalResponse) !== null && _finalResponse2 !== void 0 && _finalResponse2.message) || !(variables !== null && variables !== void 0 && variables.followUpsEnabled))) {
              _context2.next = 44;
              break;
            }
            return _context2.abrupt("continue", 28);
          case 44:
            finalResponse.message.nlpFollowUpResults = {
              followUps: parsedData.queries
            };
            done = true;
            _context2.next = 54;
            break;
          case 48:
            finalResponse = parsedData;
            onStreamFinalResponse === null || onStreamFinalResponse === void 0 || onStreamFinalResponse();
            if (!(variables !== null && variables !== void 0 && variables.followUpsEnabled)) {
              done = true;
            }
            if (!generatorConfig.yieldFinalResponse) {
              _context2.next = 54;
              break;
            }
            _context2.next = 54;
            return finalResponse;
          case 54:
            _context2.next = 28;
            break;
          case 56:
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
            _context2.next = 18;
            break;
          case 59:
            if (!(((_finalResponse3 = finalResponse) === null || _finalResponse3 === void 0 ? void 0 : _finalResponse3.type) !== AIAnswerQueryStreamType.FinalResponse)) {
              _context2.next = 61;
              break;
            }
            return _context2.abrupt("return", {
              state: 'failed',
              reason: 'parsing',
              error: 'Unexpected final response value'
            });
          case 61:
            return _context2.abrupt("return", {
              state: 'complete',
              value: finalResponse
            });
          case 64:
            _context2.prev = 64;
            _context2.t0 = _context2["catch"](11);
            return _context2.abrupt("return", {
              state: 'failed',
              reason: 'parsing',
              error: _context2.t0
            });
          case 67:
            _context2.next = 78;
            break;
          case 69:
            _context2.prev = 69;
            _context2.t1 = _context2["catch"](0);
            if (!(_context2.t1 instanceof DOMException && _context2.t1.name === 'AbortError')) {
              _context2.next = 73;
              break;
            }
            return _context2.abrupt("return", {
              state: 'failed',
              reason: 'aborted'
            });
          case 73:
            if (!(_context2.t1 instanceof DOMException && _context2.t1.name === 'TimeoutError')) {
              _context2.next = 75;
              break;
            }
            return _context2.abrupt("return", {
              state: 'failed',
              reason: 'timeout'
            });
          case 75:
            if (!(_context2.t1 instanceof Error)) {
              _context2.next = 77;
              break;
            }
            return _context2.abrupt("return", {
              state: 'failed',
              reason: 'error',
              details: _context2.t1.message,
              error: _context2.t1
            });
          case 77:
            return _context2.abrupt("return", {
              state: 'failed',
              reason: 'unknown'
            });
          case 78:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 69], [11, 64]]);
    })();
  });
  return _sainStreamFetchHandlerAssistanceService.apply(this, arguments);
}
export function sainRestFetchHandlerAssistanceService(_x3) {
  return _sainRestFetchHandlerAssistanceService.apply(this, arguments);
}
function _sainRestFetchHandlerAssistanceService() {
  _sainRestFetchHandlerAssistanceService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7) {
    var variables, isReadingAids, fetchConfig, _getAgentAndExperienc2, experience, named_id, url, response, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          variables = _ref7.variables, isReadingAids = _ref7.isReadingAids, fetchConfig = _ref7.fetchConfig;
          _getAgentAndExperienc2 = getAgentAndExperience(isReadingAids), experience = _getAgentAndExperienc2.experience, named_id = _getAgentAndExperienc2.named_id;
          url = "".concat((fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.hostName) || '').concat(ASSISTANCE_SERVICE_API_BASE_URL, "/chat/v1/invoke_agent");
          _context3.next = 5;
          return fetch(url, {
            method: 'POST',
            headers: _objectSpread({
              'Content-Type': 'application/json',
              'X-Product': 'confluence',
              'X-Experience-Id': experience
            }, fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.headers),
            body: JSON.stringify({
              recipient_agent_named_id: named_id,
              agent_input: getAgentInput({
                variables: variables,
                fetchConfig: fetchConfig
              })
            }),
            credentials: (fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.credentials) || 'same-origin',
            // fetch() uses 'same-origin' by default
            signal: fetchConfig !== null && fetchConfig !== void 0 && fetchConfig.timeout ? AbortSignal.timeout(fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.timeout) : undefined
          });
        case 5:
          response = _context3.sent;
          _context3.next = 8;
          return response.json();
        case 8:
          data = _context3.sent;
          if (!('message_template' in data)) {
            _context3.next = 11;
            break;
          }
          return _context3.abrupt("return", {
            nlpSearch: {
              errorState: mapErrorToSain(data),
              disclaimer: null,
              format: NLPSearchResultFormat.MARKDOWN,
              uniqueSources: []
            }
          });
        case 11:
          return _context3.abrupt("return", {
            nlpSearch: mapMessageToNLPSearchType(data)
          });
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _sainRestFetchHandlerAssistanceService.apply(this, arguments);
}